export default __webpack_public_path__ + "static/media/vuesax-linear-calendar.ebe3853b.svg";